namespace Matrix.Workflow {
    export class WorkflowStatusColumns {
        static columnsKey = 'Workflow.WorkflowStatus';
    }
}
